import { render, staticRenderFns } from "./RipaAdminWrapper.vue?vue&type=template&id=93b00c44&scoped=true"
import script from "./RipaAdminWrapper.vue?vue&type=script&lang=js"
export * from "./RipaAdminWrapper.vue?vue&type=script&lang=js"
import style0 from "./RipaAdminWrapper.vue?vue&type=style&index=0&id=93b00c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b00c44",
  null
  
)

export default component.exports